<template>
  <card class="card" title="Request Funds From Institution">
    <div>
      <form @submit.prevent>
        <div class="row">
          <div class="col-md-5">
            <fg-input
              type="text"
              label="Amount"
              placeholder="Amount"
              v-model="request.amount"
            >
            </fg-input>
          </div>
        </div>

        <div class="text-center">
          <p-button type="info" round @click.native.prevent="submit">
            <div
              class="spinner-grow"
              role="status"
              v-if="loading.show === true"
            ></div>
            Request
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Multiselect from "vue-multiselect";
import axios from "../store/axios";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      request: {
        amount: "",
      },
    };
  },
  computed: {
    ...mapState(["auth", "loading"]),
  },
  methods: {
    ...mapActions(["setNotification"]),
    submit() {
      this.$confirm("Request Funds from Institution?").then(async () => {
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/funding/request/merchant`,
            this.request,
          );
          const { message } = res.data;
          this.setNotification({
            type: "success",
            message,
          });
          this.request.amount = "";
        } catch (err) {
          const data = err.response
            ? err.response.data
            : { message: err.toString() };
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Perform Action",
          });
        }
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
